// src/NotFound.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import AnimationWrapper from './AnimationWrapper';

const NotFound: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-900 flex flex-col items-center justify-center text-center px-4 relative overflow-hidden">
            
            {/* Fondo con textura sutil */}
            <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.webp')] opacity-20"></div>

            <AnimationWrapper direction="up">
                <div className="relative z-10">
                    {/* Icono de GPS / Mapa perdido */}
                    <div className="text-9xl mb-4 opacity-80">🧭</div>
                    
                    <h1 className="text-6xl md:text-8xl font-extrabold text-white mb-2 tracking-tighter">
                        404
                    </h1>
                    <h2 className="text-2xl md:text-3xl font-bold text-yellow-600 mb-6 uppercase">
                        Ruta no encontrada
                    </h2>
                    
                    <p className="text-gray-400 max-w-md mx-auto mb-10 text-lg">
                        Parece que te has desviado del camino. Esta página no existe o el vehículo ya fue vendido.
                    </p>

                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <Link 
                            to="/" 
                            className="bg-yellow-600 text-white font-bold py-3 px-8 rounded-lg hover:bg-yellow-700 transition duration-300 shadow-lg"
                        >
                            Volver al Inicio
                        </Link>
                        <Link 
                            to="/catalogo" 
                            className="bg-transparent border-2 border-gray-600 text-gray-300 font-bold py-3 px-8 rounded-lg hover:border-white hover:text-white transition duration-300"
                        >
                            Ver Catálogo
                        </Link>
                    </div>
                </div>
            </AnimationWrapper>
        </div>
    );
};

export default NotFound;